import type { TpLearnMoreData, TpLearnMoreItem } from '@features/Stripe/types';

const LEARN_MORE_ITEMS: TpLearnMoreItem[] = [
  {
    icon: 'learn-more-2.1.webp',
    title: 'Instant access to your plan',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet1',
  },
  {
    icon: 'learn-more-2.0.png',
    title: '27k+ 5-star reviews',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet2',
  },
  {
    icon: 'learn-more-2.2.webp',
    title: '24/7 personal customer support',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet3',
  },
  {
    icon: 'learn-more-2.3.webp',
    title: '30 day Money Back guarantee',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet4',
  },
];

const LEARN_MORE_ITEMS_JW: TpLearnMoreItem[] = [
  {
    icon: 'learn-more-2.1.webp',
    title: 'Instant access to your plan',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet1',
  },
  {
    icon: 'emoji-graph-rise.webp',
    title: 'Detailed workout statistics',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet2.JW',
  },
  {
    icon: 'learn-more-2.2.webp',
    title: '24/7 personal customer support',
    titleId: 'Onboarding.Paywall.Main.Card.Bullet3',
  },
];

export const LEARN_MORE_VARIANT: TpLearnMoreData[] = [
  {
    learnMoreList: [...LEARN_MORE_ITEMS],
  },
];

export const LEARN_MORE_JW: TpLearnMoreData[] = [
  {
    learnMoreList: [...LEARN_MORE_ITEMS_JW],
  },
];
